module.exports = __webpack_public_path__ + "media/images/loader-208d363c641927cdfcab6e01e4425a0e.svg";